import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import videoVimeo from "./videoVimeo";

gsap.registerPlugin(ScrollTrigger);


let animHeaderHome = {
    tlPA: [],
    init() {

        if ($('body').hasClass('page-node-type-homepage')) {
            animHeaderHome.titleAnim();
            this.videoSize();

            setTimeout(function () {
                animHeaderHome.header();
                if (window.screenSize > 755) {
                    animHeaderHome.animatedPush();
                    animHeaderHome.blocPictoCadre();
                }

                animHeaderHome.blocVideo();
            }, 100);

            setTimeout(function () {
                if (window.screenSize > 755) {
                    animHeaderHome.titlePin();
                }
                $('.page-node-type-homepage').addClass('active');
            }, 1000);
        }
    },


    titleAnim() {
        let tlTitle = gsap.timeline({
            scrollTrigger: {
                trigger: '.block-page-title',
                start: '-175px top',
                end: 'bottom top',
                scrub: 1,
                pin: false,
                toggleActions: 'play none none reverse',
                markers: false,
            }
        })
        tlTitle.to(".block-page-title", {duration: 0.1, opacity: 0}, 0);
    },


    header() {
        let width1 = '70%';
        let width2 = '85%';

        if (window.screenSize < 1023) {
            width1 = '85%';
            width2 = '90%';
        }
        if (window.screenSize < 1023) {
            width1 = '100%';
            width2 = '100%';
        }

        window.id = 'video0';
        let tl = gsap.timeline({
            scrollTrigger: {
                trigger: '.bloc-anim-header-home',
                start: 'top top',
                end: 'bottom top',
                scrub: 1,
                pin: true,
                toggleActions: 'play none none reverse',
                markers: false,
            }
        })
        tl.to(".block1 img", {duration: 0.2, opacity: 0, scale: 1.2}, 0);
        tl.to(".block2", {duration: 0.2, opacity: 1}, 0);
        tl.to(".block2", {duration: 0.2, width: width1, top: 0, height: '100%'}, 0.2);
        tl.to(".block2", {duration: 0.2, opacity: 0.2, width: width2}, 0.4);
        tl.to(".block3", {duration: 0.2, opacity: 0.5, width: width2}, 0.4);
        tl.to(".block2", {duration: 0.3, opacity: 0, width: window.screen.width}, 0.6);
        tl.to(".block3", {duration: 0.3, opacity: 1, width: window.screen.width,}, 0.6);

        tl.to(".block3 .bg-anim", {duration: 0.2, opacity: 1}, 1);
        tl.to(".block3 .bg-anim", {duration: 0.3, y: '-100vh'}, 1.3);
        tl.to(".bloc-text-fond", {duration: 0.3, y: '-100vh'}, 0.3);
    },


    titlePin() {
        ScrollTrigger.create({
            trigger: '.bloc-pushs-animated',
            start: 'top top',
            end: 'bottom 65%',
            startTrigger: '.col-left .title2',
            endTrigger: '.col-right',
            scrub: 1,
            pin: '.col-left .title2',
            toggleActions: 'play none none reverse',
            markers: false,
        })
    },


    animatedPush() {
        this.videoSize();

        gsap.utils.toArray('.col-right article').forEach((section, i) => {
            let id = $(section).find('video').attr('id');

            let tlPA = gsap.timeline({
                scrollTrigger: {
                    trigger: section,
                    start: 'top 80%',
                    end: 'bottom 0%',
                    scrub: 1,
                    toggleActions: 'play none none reverse',
                    markers: false
                }
            })
            tlPA.to(section, {duration: 2, opacity: 1}, 0);
            if (id != null) {
                tlPA.add(function () {
                    videoVimeo.videoPause(id)
                }, 0);
                tlPA.add(function () {
                    videoVimeo.videoPlay(id)
                }, 0);
            }
            tlPA.to(section, {duration: 2, opacity: 0.5}, 2);
            if (id != null) {
                tlPA.add(function () {
                    videoVimeo.videoPlay(id)
                }, 2);
                tlPA.add(function () {
                    videoVimeo.videoPause(id)
                }, 2);
            }
            tlPA.to(section, {duration: 2, opacity: 0.5}, 4);
            this.tlPA.push(tlPA);
        });
    },


    videoSize() {
        var size = $('.bloc-pushs-animated article').width();

        $('.bloc-pushs-animated .videoWrapper').each(function () {
            $(this).height(size * 1.25 + 'px');
        })
    },


    blocPictoCadre() {
        let hauteur = $('.bloc-pushs-animated').outerHeight(true);
        let hauteur2 = hauteur + window.screen.height;
        let hauteur3 = hauteur2 + window.screen.height;

        $('.bloc-pictos-cadre').css('margin-top', '-' + hauteur + 'px');


        let tlPA2 = gsap.timeline({
            scrollTrigger: {
                trigger: '.bloc-pushs-animated',
                start: 'top top',
                end: hauteur3 + ' top',
                scrub: 1,
                pin: '.bloc-pictos-cadre',
                toggleActions: 'play none none reverse',
                markers: false,
            }
        })
        tlPA2.to(".bloc-pictos-cadre .title4", {duration: 1, opacity: 1, y: 0, ease: "power1.inOut"}, 2);
        tlPA2.to(".bloc-pictos-cadre .title4", {duration: 1, opacity: 0, y: '-100', ease: "power1.inOut"}, 5);
        tlPA2.to(".bloc-pictos-cadre .title4", {duration: 1, opacity: 0, y: '-100', ease: "power1.inOut"}, 7);
        tlPA2.to(".bloc-pictos-cadre .content", {duration: 1, opacity: 1, y: '0%', ease: "power1.inOut"}, 7);
        tlPA2.to(".bloc-pictos-cadre .pictos", {duration: 1, opacity: 1, y: '-100%', ease: "power1.inOut"}, 5.5);
        tlPA2.to(".bloc-pictos-cadre .bloc-picto:nth-child(1)", {
            duration: 1,
            opacity: 0,
            y: '-100',
            ease: "power1.inOut"
        }, 8.5);
        tlPA2.to(".bloc-pictos-cadre .bloc-picto:nth-child(2)", {
            duration: 1,
            opacity: 0,
            y: '-100',
            ease: "power1.inOut"
        }, 9.5);
        tlPA2.to(".bloc-pictos-cadre .bloc-picto:nth-child(3)", {
            duration: 1,
            opacity: 0,
            y: '-100',
            ease: "power1.inOut"
        }, 10.5);
        tlPA2.to(".bloc-video", {duration: 2, opacity: 1, ease: "power1.inOut"}, 12);
        tlPA2.to(".bloc-pictos-cadre .pictos", {duration: 0, opacity: 0}, 13.5);
        tlPA2.to(".bloc-pictos-cadre .content", {duration: 0, opacity: 0}, 13.5);
    },


    blocVideo() {
        window.id3 = $('.page-node-type-homepage .bloc-video video').attr('id');
        if (window.id3 !== undefined) {
            let tlBV = gsap.timeline({
                scrollTrigger: {
                    trigger: '.bloc-video',
                    start: 'top top',
                    end: 'bottom top',
                    scrub: 1,
                    pin: true,
                    toggleActions: 'play none none reverse',
                    markers: false,
                    anticipatePin: 1,
                }
            })
            tlBV.add(function () {
                videoVimeo.videoPause(window.id3)
            }, 0);
            tlBV.to(".bloc-video .videoWrapper", {
                duration: 1,
                width: '100%',
                height: '100%',
                ease: "power1.inOut"
            }, 0.3);
            tlBV.to(".bloc-video .overlay", {duration: 1, opacity: 0, ease: "power1.inOut"}, 0.3);
            tlBV.add(function () {
                videoVimeo.videoPlay(window.id3)
            }, 0.5);
            tlBV.add(function () {
                videoVimeo.videoPlay(window.id3)
            }, 2.9);
            tlBV.add(function () {
                videoVimeo.videoPause(window.id3)
            }, 3);
        }
    }

}

export default animHeaderHome;
